import { FC } from 'react';

import Page from '@/components/Page.tsx';

const ProfilePage: FC = () => {
    // eslint-disable-next-line i18next/no-literal-string
    return <Page fullScreen>Profile Page</Page>;
};

export default ProfilePage;
